// Every downloadable file the pages link to, in one place.
// `undefined` means the client has not sent it yet: the page then shows
// "PDF soon" instead of a link, so nothing on the site pretends to download.
// The numbers refer to client-content/REQUEST-LIST.md. When a file arrives,
// copy it into public/files/ and put its path here.
type MaybeFile = string | undefined;

export const FILES: {
  committeeList: MaybeFile;
  isoCertificate: MaybeFile;
  aimsAndObjectives: MaybeFile; // 7
  affiliationRules: MaybeFile; // 5
  affiliationForm: MaybeFile; // 5
  examApplicationForm: MaybeFile; // 4
  seatNumbers: MaybeFile; // 4
  meritList: MaybeFile; // 4
  revisedCourseFee: MaybeFile; // 4
  syllabi: Record<string, MaybeFile>; // 6, keyed by faculty slug, e.g. electrical
} = {
  committeeList: '/files/circulars/managing-committee-2025-27.pdf',
  isoCertificate: '/files/circulars/iso-9001-uqsr.pdf',
  aimsAndObjectives: undefined,
  affiliationRules: undefined,
  affiliationForm: undefined,
  examApplicationForm: undefined,
  seatNumbers: undefined,
  meritList: undefined,
  revisedCourseFee: undefined,
  syllabi: {},
};
